<template>
  <div
    class="text-whitebase w-full h-full rounded"
    ref="target"
    style="
      width: 282px;
      height: 56px;
      border: 1px solid rgba(255, 255, 255, 0.15);
    "
  >
    <div
      class="flex items-center h-full px-4 justify-between text-base"
      style="color: #ffffff66"
      v-if="!state.status"
      @click="onFocus"
    >
      {{ placeholder }}
      <i class="iconfont icon-sousuo1 ml-1" style="font-size: inherit"></i>
    </div>
    <div v-else class="flex h-full rounded relative">
      <input
        ref="inputRef"
        class="w-full bg-transparent border-0 px-4 py-1"
        v-model="state.word"
        :placeholder="placeholder"
        type="text"
        @focus="
          state.focus = true;
          state.focused = true;
        "
        @blur="state.focused = false"
      />
      <div
        v-if="state.word && state.focus"
        class="
          w-4
          h-4
          flex
          justify-center
          items-center
          rounded-full
          absolute
          right-2
          top-1/2
          transform
          -translate-y-1/2
          cursor-pointer
        "
        style="background: #ffffff1a"
        @click="state.word = ''"
      >
        <i class="iconfont icon-guanbi text-xs"></i>
      </div>

      <div
        class="
          absolute
          -bottom-2
          left-0
          transform
          translate-y-full
          p-2
          w-full
          rounded-sm
          font-normal
          text-left
          z-40
        "
        style="background: #2a2e33ff"
        v-if="state.focus"
      >
        <div v-if="loading" class="flex items-center justify-center h-4">
          <Spin></Spin>
        </div>
        <UiScrollBars v-else-if="state.result.length > 0" class="w-full h-36">
          <div v-for="(item, i) in lists" :key="i" @click="onSelect(i)">
            <div
              class="flex items-center cursor-pointer item-hover rounded-sm p-2"
            >
              <UiImg class="w-5 h-5 rounded-full mr-2" :src="item.logo"></UiImg>

              <span>
                {{ item.name }}
              </span>
            </div>
          </div>
        </UiScrollBars>

        <div v-else>No items found</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  defineProps,
  nextTick,
  reactive,
  ref,
  watch,
  defineEmits,
  onMounted,
  computed,
} from 'vue';
import { onClickOutside } from '@vueuse/core';
import Spin from '@/components/Spin.vue';
import UiScrollBars from '@/components/UiScrollbars.vue';
import { useReqByBool } from '@/hooks';
import { searchDao } from '@/api/dao';
import UiImg from '@/components/UiImg.vue';

const target = ref(null);
const inputRef = ref(null);

const $emits = defineEmits(['lay', 'update:modelValue']);

const props = defineProps({
  placeholder: String,
  alignRight: Boolean,
  onSearch: Function,
  modelValue: String,
});

const state = reactive({
  word: props?.modelValue?.name || '',
  status: !!props?.modelValue?.name,
  focus: false,
  focused: false,
  result: [],
  selectItem: null,
});

const { loadData, loading } = useReqByBool(async () => {
  const res = await searchDao(state.word);
  state.result = res;
  console.log(res);
});

watch(
  () => state.word,
  () => {
    loadData();
  },
);

watch(
  () => JSON.stringify(props.modelValue),
  () => {
    if (props.modelValue.name) {
      state.status = true;
    }

    state.word = props.modelValue.name;
  },
);

const lists = computed(() =>
  state.result.filter((x) => {
    const index = x.name.indexOf(state.word);
    return index != -1;
  }),
);

const onSelect = (i) => {
  state.focus = false;
  state.selectItem = lists.value[i];
  state.word = state.selectItem.name;
  $emits('update:modelValue', state.selectItem);
};

onClickOutside(target, () => {
  if (!state.word) state.status = false;
  state.focus = false;
});

const onFocus = () => {
  state.status = true;
  state.focus = true;

  nextTick(() => {
    inputRef.value.focus();
  });
};

onMounted(() => {
  loadData();
});
</script>

<style scoped>
.item-hover:hover {
  background: #ffffff0d;
}
</style>
